var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('meta',{attrs:{"charset":"utf-8"}}),_c('meta',{attrs:{"name":"viewport","content":"width=device-width, initial-scale=1.0"}}),_c('FullView2021')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }